import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, shadows, spacing }) => ({
  drawer: {
    backgroundColor: "white",
    bottom: 0,
    boxShadow: shadows[10],
    display: "flex",
    flexDirection: "column",
    left: 0,
    position: "absolute",
    top: 0,
    width: spacing(8),
    zIndex: 999,
  },
  "drawer--dangerous": {
    bottom: 30,
  },
  "drawer--expanded": {
    width: spacing(32),
  },
  drawer__footer: { flexGrow: 0 },
  drawer__header: {
    alignItems: "center",
    backgroundColor: palette.primary.main,
    display: "flex",
    flexGrow: 0,
    height: spacing(8),
    justifyContent: "flex-start",
    paddingLeft: spacing(1),
  },
  drawer__header_icon: { color: palette.background.paper },
  drawer__header_logo: { color: palette.background.paper },
  drawer__list: {
    flexGrow: 1,
    height: 0,
    overflowX: "hidden",
    overflowY: "auto",
  },
  drawer__time: {
    "& > div": {
      backgroundColor: palette.default.light,
    },
    flexGrow: 0,
  },
  version: {
    color: palette.common.white,
    fontSize: 10,
  },
}));
